module.exports.GET_USER = 'GET_USER';
